import { render, staticRenderFns } from "./SplitTruck.vue?vue&type=template&id=fdbcb104"
import script from "./SplitTruck.vue?vue&type=script&lang=ts"
export * from "./SplitTruck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports